module.exports = __webpack_public_path__ + "static/img/guide2.70e91fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide2.png
// module id = LEH4
// module chunks = 2